(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('typingService',
            ['$log', '$timeout', '$rootScope', '$stateParams', 'comapiChatService',
                function ($log, $timeout, $rootScope, $stateParams, comapiChatService) {

                    var timeoutVal = 5000;

                    var _setTypingOffTimeout = undefined;
                    var _sendTypingOffTimeout = undefined;

                    var _participantProfileId = undefined;


                    function _set(typing) {
                        $rootScope.$apply(function () {
                            fac.isTyping = typing;
                        });
                    }

                    $rootScope.$on('appMessaging.participantTyping', function (event, data) {
                        if (data.conversationId === $stateParams.id &&
                            data.profileId === _participantProfileId) {

                            _setTypingOffTimeout =
                                $timeout(function () {
                                    _setTypingOffTimeout = undefined;
                                    _set(false);
                                }, timeoutVal);

                            _set(true);
                        }
                    });

                    $rootScope.$on('appMessaging.participantTypingOff', function (event, data) {
                        if (data.conversationId === $stateParams.id &&
                            data.profileId === _participantProfileId) {
                            _clearSetTypingOffTimeout();
                            _set(false);
                        }
                    });

                    function _clearSetTypingOffTimeout() {
                        if (_setTypingOffTimeout) {
                            $log.log("Clearing _setTypingOffTimeout timeout");
                            $timeout.cancel(_setTypingOffTimeout);
                            _setTypingOffTimeout = undefined;
                        }
                    }

                    function _sendIsTypingOn() {
                        $log.log("_sendIsTypingOn()");
                        comapiChatService.chatClient.messaging.sendIsTyping($stateParams.id);

                        // set a timeout / optionally cancel one already in flight
                        _clearSendTypingOffTimeout();

                        _sendTypingOffTimeout =
                            $timeout(function () {
                                // _sendTypingOffTimeout = undefined;
                                // timeout is cleared in sendIsTypingOff - UI may call that when message is sent
                                fac.sendIsTypingOff();
                            }, timeoutVal);
                    }

                    function _clearSendTypingOffTimeout() {
                        if (_sendTypingOffTimeout) {
                            $log.log("Clearing sendTypingOffTimeout timeout");
                            $timeout.cancel(_sendTypingOffTimeout);
                            _sendTypingOffTimeout = undefined;
                        }
                    }

                    var fac = {
                        /**
                         * 
                         */
                        start: function (participantProfileId) {
                            _participantProfileId = participantProfileId;
                        },
                        /**
                         * 
                         */
                        stop: function () {
                            fac.isTyping = false;
                            _participantProfileId = undefined;
                            _clearSendTypingOffTimeout();
                            _clearSetTypingOffTimeout();
                        },
                        /**
                         * For unit test ...
                         */
                        hasPendingOperations: function () {
                            return _sendTypingOffTimeout || _setTypingOffTimeout;
                        },
                        /**
                         * 
                         */
                        isTyping: false,
                        /**
                         * 
                         */
                        sendIsTypingOn: COMAPI_CHAT.Utils.debounce(_sendIsTypingOn, 1000, true),
                        /**
                         * 
                         */
                        sendIsTypingOff: function () {
                            $log.log("sendIsTypingOff()");
                            _clearSendTypingOffTimeout();
                            return comapiChatService.chatClient.messaging.sendIsTypingOff($stateParams.id);
                        }
                    };

                    return fac;
                }]);

})(window.angular);